
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/u/[username]/wishlist",
      function () {
        return require("private-next-pages/u/[username]/wishlist.js");
      }
    ]);
  